import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Panveltopunecab() {



  const cardData = {


  keyword: "Panvel to Pune Cab",

  headingDescription: "Trustline Cab provides reliable Panvel to Pune cab services with safe, comfortable, and affordable transportation for business travel, corporate meetings, airport transfers, family trips, industrial visits, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our experienced chauffeurs ensure timely pickups, smooth travel via the Mumbai-Pune Expressway, and a hassle-free journey from Panvel to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, well-maintained vehicles, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Panvel to Pune taxi services.",

  topPlaces: [
    {
      title: "Kharadi",
      description: "Kharadi is one of Pune's leading IT and business destinations, home to EON IT Park, multinational companies, corporate offices, premium hotels, and modern commercial developments. It is a preferred destination for business travelers."
    },
    {
      title: "Pimpri Chinchwad",
      description: "Pimpri Chinchwad is one of Maharashtra's largest industrial and commercial regions, known for automobile companies, engineering industries, manufacturing units, business parks, and modern infrastructure."
    },
    {
      title: "Baner",
      description: "Baner is a thriving commercial and residential locality featuring IT companies, business parks, cafés, educational institutions, restaurants, and premium housing projects. It is a popular destination for professionals."
    },
    {
      title: "Chakan MIDC",
      description: "Chakan MIDC is a major industrial hub housing automobile manufacturers, engineering companies, logistics centers, and production facilities. It is an important destination for industrial and corporate travel."
    },
    {
      title: "Magarpatta City",
      description: "Magarpatta City is a world-class integrated township featuring IT parks, corporate offices, shopping malls, hotels, and residential communities. It is a preferred destination for business executives and families."
    },
    {
      title: "Wakad",
      description: "Wakad is a rapidly growing suburb known for commercial complexes, residential developments, restaurants, educational institutions, and excellent connectivity to Hinjewadi and other business hubs."
    },
    {
      title: "Aga Khan Palace",
      description: "Aga Khan Palace is one of Pune's most iconic historical landmarks, admired for its elegant architecture, beautiful gardens, and important role in India's freedom movement. It is a must-visit attraction for tourists."
    },
    {
      title: "Parvati Hill",
      description: "Parvati Hill is a famous heritage destination offering ancient temples, panoramic views of Pune city, peaceful surroundings, and a memorable sightseeing experience for visitors."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a picturesque hill station situated between Panvel and Pune, famous for waterfalls, scenic valleys, viewpoints, caves, and pleasant weather. It is a favorite stop for travelers on this route."
    },
    {
      title: "Karla Caves",
      description: "Karla Caves are ancient Buddhist rock-cut caves near Lonavala, renowned for their magnificent architecture, historic carvings, and cultural significance. They are among the most visited attractions on the Mumbai–Pune route."
    }
  ],






"services": [
  {
    "name": "Panvel Station to Pune Taxi",
    "description": "Book Panvel Station to Pune Taxi with professional chauffeurs, clean AC Sedan, Ertiga, Innova, Innova Crysta, and SUV vehicles for safe and comfortable travel. Enjoy fixed fares, doorstep pickup, railway station transfers, online booking, luggage assistance, one way and round trip options, family travel, business trips, and 24x7 customer support with transparent pricing."
  },
  {
    "name": "Panvel to Pune Cab Charges",
    "description": "Check Panvel to Pune Cab Charges with affordable pricing, fixed fare packages, transparent billing, multiple vehicle choices, and comfortable chauffeur-driven travel for business, family, and outstation trips."
  },
  {
    "name": "Panvel to Pune Cab Fare",
    "description": "Find the latest Panvel to Pune Cab Fare for Sedan, Ertiga, Innova, Innova Crysta, and SUV vehicles with fixed pricing, no hidden charges, reliable drivers, and convenient online booking."
  },
  {
    "name": "Panvel to Pune Distance Taxi Fare",
    "description": "Get Panvel to Pune Distance Taxi Fare with transparent per km rates, fixed fare options, experienced drivers, AC vehicles, and comfortable intercity transportation."
  },
  {
    "name": "Panvel to Pune Taxi",
    "description": "Book Panvel to Pune Taxi for comfortable highway travel with experienced chauffeurs, sanitized AC cars, flexible pickup timings, luggage assistance, and dependable outstation taxi services."
  },
  {
    "name": "Panvel to Pune Taxi Fare",
    "description": "Check Panvel to Pune Taxi Fare with affordable rates, premium vehicles, instant booking confirmation, and safe intercity travel backed by professional customer support."
  },
  {
    "name": "Panvel to Pune Innova Cab",
    "description": "Reserve Panvel to Pune Innova Cab for family vacations, corporate travel, airport transfers, group journeys, spacious seating, and premium chauffeur-driven comfort."
  },
  {
    "name": "Panvel to Pune One Way Cab",
    "description": "Book Panvel to Pune One Way Cab with fixed fares, online booking, clean AC vehicles, professional drivers, and doorstep pickup for hassle-free travel."
  },
  {
    "name": "Panvel to Pune Round Trip Cab",
    "description": "Choose Panvel to Pune Round Trip Cab with flexible return timing, experienced chauffeurs, premium vehicles, affordable packages, and convenient outstation travel."
  },
  {
    "name": "Panvel to Pune Station Cab Fare",
    "description": "Check Panvel to Pune Station Cab Fare with fixed pricing, multiple vehicle options, railway station pickup and drop service, and comfortable long-distance transportation."
  },
  {
    "name": "Panvel to Baner Cab",
    "description": "Book Panvel to Baner Cab for safe and reliable travel with professional drivers, AC vehicles, affordable pricing, and convenient doorstep pickup."
  },
  {
    "name": "Panvel to Hinjewadi Cab",
    "description": "Reserve Panvel to Hinjewadi Cab for IT park transfers, business meetings, corporate travel, and comfortable chauffeur-driven transportation with fixed fares."
  },
  {
    "name": "Panvel to Pune Ertiga Cab",
    "description": "Hire Panvel to Pune Ertiga Cab for spacious six-seater travel, family vacations, airport transfers, business trips, and comfortable outstation journeys."
  },
  {
    "name": "Cab Service in Panvel",
    "description": "Choose Cab Service in Panvel for local rides, airport transfers, railway station pickup, Pune trips, outstation travel, clean AC vehicles, and experienced chauffeurs."
  },
  {
    "name": "Panvel Outstation Taxi Service",
    "description": "Book Panvel Outstation Taxi Service for one way, round trip, airport transfers, family vacations, corporate travel, and reliable chauffeur-driven journeys."
  },
  {
    "name": "Cheapest Taxi Service in Panvel",
    "description": "Hire the Cheapest Taxi Service in Panvel with budget-friendly fares, clean AC cars, professional drivers, transparent pricing, and dependable travel services."
  },
  {
    "name": "Taxi Service in Churchgate",
    "description": "Book Taxi Service in Churchgate for Mumbai local travel, airport transfers, Pune outstation cabs, business travel, and comfortable chauffeur-driven transportation."
  },
  {
    "name": "Panvel to Pune Cab",
    "description": "Reserve Panvel to Pune Cab with premium Sedan, Ertiga, Innova Crysta, and SUV vehicles, professional chauffeurs, affordable pricing, and smooth highway travel."
  },
  {
    "name": "Panvel to Pune Cab Service",
    "description": "Our Panvel to Pune Cab Service offers fixed fares, experienced drivers, online booking, doorstep pickup, premium vehicles, and 24x7 customer support."
  },
  {
    "name": "Panvel to Pune Taxi Service",
    "description": "Choose Panvel to Pune Taxi Service for comfortable one way and round trip travel with AC vehicles, transparent pricing, and experienced chauffeurs."
  },
  {
    "name": "Panvel to Pune One Way Cab",
    "description": "Travel with Panvel to Pune One Way Cab featuring affordable pricing, professional drivers, luggage assistance, and safe intercity transportation."
  },
  {
    "name": "Panvel to Pune Taxi Fare",
    "description": "Compare Panvel to Pune Taxi Fare with fixed pricing, premium vehicles, economical packages, and transparent billing without hidden charges."
  },
  {
    "name": "Panvel to Pune Cab Booking",
    "description": "Complete Panvel to Pune Cab Booking online with instant confirmation, multiple vehicle options, secure reservations, and professional chauffeur service."
  },
  {
    "name": "Cab from Panvel to Pune",
    "description": "Book Cab from Panvel to Pune with clean AC cars, punctual pickup, experienced drivers, affordable fares, and comfortable outstation travel."
  },
  {
    "name": "Panvel to Pune Car Rental",
    "description": "Hire Panvel to Pune Car Rental with Sedan, Ertiga, Innova, Innova Crysta, and SUV vehicles for family trips, corporate travel, and airport transfers."
  },
  {
    "name": "Panvel to Pune Taxi Booking Online",
    "description": "Reserve Panvel to Pune Taxi Booking Online with quick confirmation, secure payment, transparent fares, and reliable chauffeur-driven transportation."
  },
  {
    "name": "Cheap Cab Panvel to Pune",
    "description": "Choose Cheap Cab Panvel to Pune for budget-friendly travel with professional drivers, AC vehicles, fixed pricing, and comfortable long-distance journeys."
  },
  {
    "name": "Panvel to Pune Outstation Cab",
    "description": "Book Panvel to Pune Outstation Cab with experienced chauffeurs, premium vehicles, flexible pickup timings, and dependable intercity transportation."
  },
  {
    "name": "Panvel to Pune AC Taxi Service",
    "description": "Travel with Panvel to Pune AC Taxi Service featuring sanitized air-conditioned vehicles, fixed fares, comfortable seating, and smooth highway rides."
  },
  {
    "name": "Panvel to Pune Innova Cab",
    "description": "Reserve Panvel to Pune Innova Cab for spacious family travel, business meetings, airport transfers, group tours, and luxury outstation journeys."
  },
  {
    "name": "Panvel to Pune SUV Taxi",
    "description": "Book Panvel to Pune SUV Taxi with premium SUV vehicles, experienced chauffeurs, spacious luggage capacity, fixed pricing, and comfortable long-distance travel."
  },
  {
    "name": "Panvel to Pune Cab Price",
    "description": "Check Panvel to Pune Cab Price with affordable fare options, transparent pricing, Sedan, Ertiga, Innova Crysta, and SUV choices for every travel requirement."
  }
],

"tableData": [
  ["Panvel Station to Pune Taxi", "Panvel to Pune Cab Charges"],
  ["Panvel to Pune Cab Fare", "Panvel to Pune Distance Taxi Fare"],
  ["Panvel to Pune Taxi", "Panvel to Pune Taxi Fare"],
  ["Panvel to Pune Innova Cab", "Panvel to Pune One Way Cab"],
  ["Panvel to Pune Round Trip Cab", "Panvel to Pune Station Cab Fare"],
  ["Panvel to Baner Cab", "Panvel to Hinjewadi Cab"],
  ["Panvel to Pune Ertiga Cab", "Cab Service in Panvel"],
  ["Panvel Outstation Taxi Service", "Cheapest Taxi Service in Panvel"],
  ["Taxi Service in Churchgate", "Panvel to Pune Cab"],
  ["Panvel to Pune Cab Service", "Panvel to Pune Taxi Service"],
  ["Panvel to Pune One Way Cab", "Panvel to Pune Taxi Fare"],
  ["Panvel to Pune Cab Booking", "Cab from Panvel to Pune"],
  ["Panvel to Pune Car Rental", "Panvel to Pune Taxi Booking Online"],
  ["Cheap Cab Panvel to Pune", "Panvel to Pune Outstation Cab"],
  ["Panvel to Pune AC Taxi Service", "Panvel to Pune Innova Cab"],
  ["Panvel to Pune SUV Taxi", "Panvel to Pune Cab Price"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Panvel to Pune Cab Service",
    WhyChoosedescription: "Trustline Cab offers dependable Panvel to Pune cab services with experienced chauffeurs, comfortable vehicles, and convenient intercity travel for every journey."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Panvel",
    WhyChoosedescription: "Enjoy hassle-free pickup from Panvel Railway Station, New Panvel, Kamothe, Kalamboli, Khandeshwar, hotels, offices, and residential areas with direct drop anywhere in Pune."
  },
  {
    WhyChooseheading: "Safe & Comfortable Expressway Travel",
    WhyChoosedescription: "Our professional drivers ensure a smooth and secure journey through the Mumbai–Pune Expressway while maintaining punctual pickups and comfortable travel."
  },
  {
    WhyChooseheading: "Multiple Vehicle Choices",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your passenger count and luggage requirements."
  },
  {
    WhyChooseheading: "Affordable Fare with Complete Transparency",
    WhyChoosedescription: "Receive clear pricing before booking with competitive cab fares and no hidden charges during your Panvel to Pune trip."
  },
  {
    WhyChooseheading: "One Way & Round Trip Cab Options",
    WhyChoosedescription: "Book one-way cabs, return journeys, or customized travel packages according to your travel schedule and destination."
  },
  {
    WhyChooseheading: "Suitable for Corporate & Family Travel",
    WhyChoosedescription: "Our Panvel to Pune cab service is ideal for business meetings, airport transfers, family vacations, medical visits, and personal travel."
  },
  {
    WhyChooseheading: "24/7 Booking & Customer Support",
    WhyChoosedescription: "Book your Panvel to Pune cab anytime with instant confirmation and dedicated customer support for a smooth travel experience."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Panvel to Pune cab service?",
    answer: "Yes, Trustline Cab offers reliable Panvel to Pune cab services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Panvel to Pune?",
    answer: "Yes, one-way cab services are available with doorstep pickup from Panvel and direct drop anywhere in Pune."
  },
  {
    question: "Do you provide pickup from Panvel Railway Station and nearby areas?",
    answer: "Yes, we provide pickup from Panvel Railway Station, New Panvel, Kamothe, Kalamboli, Khandeshwar, and nearby locations."
  },
  {
    question: "Which vehicles are available for Panvel to Pune travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable intercity travel."
  },
  {
    question: "Is Panvel to Pune cab service available 24 hours?",
    answer: "Yes, our cab service operates 24/7, allowing you to travel according to your preferred schedule."
  },
  {
    question: "Can I reserve a return cab from Pune to Panvel?",
    answer: "Yes, round-trip cab services are available for passengers planning return travel between Pune and Panvel."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically included in the confirmed booking quotation."
  },
  {
    question: "Should I reserve my Panvel to Pune cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and your preferred pickup timing."
  },
  {
    question: "Do you provide Panvel to Pune cabs for corporate travel?",
    answer: "Yes, our cab services are suitable for business meetings, employee transportation, client visits, and regular corporate travel."
  },
  {
    question: "How can I book Panvel to Pune Cab with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Patwardhan",
    feedback: "Trustline Travels provided an excellent Panvel to Pune cab experience with a punctual driver, clean vehicle, and smooth journey. Everything was professionally managed from pickup to drop.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Deepa Kulkarni",
    feedback: "The booking process was quick, the cab was spacious, and the driver was courteous throughout the trip. Our Panvel to Pune journey was comfortable, safe, and completely hassle-free.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Panvel to Pune Cab",
  "image": "https://www.trustlinetravels.com/assets/images/panvel-to-pune-cab.webp",
  "description":
    "Book Panvel to Pune Cab with Trustline Travels for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Panvel Railway Station and all Panvel locations to Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 at the best fares.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/panvel-to-pune-cab"
  }
};



  return (
    <div>

<Helmet>
  <title>Panvel to Pune Cab | One Way Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Panvel to Pune Cab with Trustline Travels for reliable one-way and round-trip taxi services. Get affordable cabs from Panvel Railway Station and all Panvel locations to Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7."
  />

  <meta
    name="keywords"
    content="panvel station to pune taxi, panvel to pune cab charges, panvel to pune cab fare, panvel to pune distance taxi fare, panvel to pune taxi, panvel to pune one way cab, panvel to pune round trip cab, Panvel to Pune Cab, Panvel Pune Taxi Service, Panvel to Pune Cab Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/23.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Panveltopunecab;